import React from "react";
import moment from "moment";

const TrainerSession = ({ closeModal, rowData }) => {
  const threeDayDetails = rowData?.three_day_details || [];
  const completedCount = rowData?.three_day_done_count || 0;

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "verified":
        return "#209216";
      case "pending":
        return "#D78B03";
      case "cancelled":
        return "#E41815";
      default:
        return "#898989";
    }
  };

  const getTrainerStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "active":
        return "#209216";
      case "inactive":
        return "#E41815";
      default:
        return "#898989";
    }
  };

  return (
    <div className="trainer-session-container" style={{ padding: "20px" }}>
      <div className="session-summary" style={{ marginBottom: "20px" }}>
        <h4 style={{ margin: "0 0 10px 0", color: "#333" }}>Session Summary</h4>
        <p style={{ margin: "0", fontSize: "16px", color: "#666" }}>
          Total Completed Sessions: <strong>{completedCount}</strong>
        </p>
      </div>

      {threeDayDetails?.length > 0 ? (
        <div className="trainer-details-list">
          <h4 style={{ margin: "0 0 15px 0", color: "#333" }}>
            Trainer Session Details
          </h4>

          <div
            className="details-table"
            style={{
              border: "1px solid #ddd",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <div
              className="table-header"
              style={{
                backgroundColor: "#f8f9fa",
                padding: "12px",
                borderBottom: "1px solid #ddd",
                display: "grid",
                gridTemplateColumns: "2fr 1fr 1fr 1fr",
                gap: "10px",
                fontWeight: "600",
                fontSize: "14px",
                color: "#333",
              }}
            >
              <div>Trainer Name</div>
              <div>Date</div>
              <div>Trainer Status</div>
              <div>Session Status</div>
            </div>

            {threeDayDetails?.map((session, index) => (
              <div
                key={index}
                className="table-row"
                style={{
                  padding: "12px",
                  borderBottom:
                    index < threeDayDetails.length - 1
                      ? "1px solid #eee"
                      : "none",
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr 1fr 1fr",
                  gap: "10px",
                  fontSize: "14px",
                  backgroundColor: index % 2 === 0 ? "#fff" : "#fafafa",
                }}
              >
                <div style={{ fontWeight: "500", color: "#333" }}>
                  {session.trainer_name?.trim() || "N/A"}
                </div>

                <div style={{ color: "#666" }}>
                  {session.date
                    ? moment(session.date, "DD-MM-YYYY").format("DD MMM YYYY")
                    : "N/A"}
                </div>

                <div>
                  <span
                    style={{
                      color: getTrainerStatusColor(session.trainer_status),
                      fontWeight: "500",
                      textTransform: "capitalize",
                    }}
                  >
                    {session.trainer_status || "N/A"}
                  </span>
                </div>

                <div>
                  <span
                    style={{
                      color: getStatusColor(session.trial_status),
                      fontWeight: "500",
                      textTransform: "capitalize",
                      padding: "4px 8px",
                      backgroundColor: `${getStatusColor(
                        session.trial_status
                      )}15`,
                      borderRadius: "12px",
                      fontSize: "12px",
                    }}
                  >
                    {session.trial_status || "N/A"}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div
          className="no-data"
          style={{
            textAlign: "center",
            padding: "40px 20px",
            color: "#666",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px",
            border: "1px solid #eee",
          }}
        >
          <p style={{ margin: "0", fontSize: "16px" }}>
            No trainer session details available
          </p>
        </div>
      )}

      {/* <div
        className="action-buttons"
        style={{
          marginTop: "20px",
          textAlign: "right",
        }}
      >
        <button
          onClick={closeModal}
          style={{
            padding: "10px 20px",
            backgroundColor: "#6c757d",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "14px",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#5a6268")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#6c757d")}
        >
          Close
        </button>
      </div> */}
    </div>
  );
};

export default TrainerSession;
